import * as zod from 'zod'

const name = zod.string().trim().min(1, {message: 'required'}).max(128)

const tripIds = zod.array(zod.object({
  value: zod.number(),
  label: zod.string(),
}))

const team = zod.boolean()

const token = zod.string()

export const AddAclSchema = zod.object({name, team, token, tripIds})
export type AddAclSchema = zod.infer<typeof AddAclSchema>

export const UpdateAclSchema = zod.object({name, team, token, tripIds})
export type UpdateAclSchema = zod.infer<typeof UpdateAclSchema>